type IconProps = {
  onClick?: React.MouseEventHandler<SVGSVGElement>;
};

export const CloseIcon: React.FC<IconProps> = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1 10.8969L5.94845 5.94845L10.8969 10.8969M10.8969 1L5.94751 5.94845L1 1'
        stroke='white'
        strokeOpacity='1'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
